// extracted by mini-css-extract-plugin
export var productImage = "_w2-0";